import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SidebarLayout } from './SidebarLayout';
import { DashboardHeaderLayout } from './DashboardHeaderLayout';
import { PageErrorBoundary } from '../PageErrorBoundary';
import { PartnerProvider } from '../../features/partner/core/PartnerContext';
import { WhatsNewDialog } from '../../features/overview/components/WhatsNewDialog';

/* shown while a lazily loaded page chunk is being fetched */
function PageFallback() {
  const { t } = useTranslation();
  return (
    <p role="status" aria-busy="true" className="page-loading">
      {t('common.loading')}
    </p>
  );
}

/*
 * Keep this Layout as a Wrapper:
 * This layout only defines the CSS grid/flex structure and assembles the pieces.
 *
 * Performance:
 * Having a sidebar layout,
 * React only re-renders the specific component that changed.
 * Toggling the sidebar no longer forces the Outlet
 * (main content) to check for updates.
 */
export function DashboardLayout() {
  return (
    <PartnerProvider>
      {/* the news of a build that arrived since the last visit — behind
          the login, because that is where the news happens */}
      <WhatsNewDialog />

      <div className="app-shell">
        {/*sidebar*/}
        <SidebarLayout />

        {/*main*/}
        <div className="app-content">
          {/*header*/}
          <DashboardHeaderLayout />

          {/*body*/}
          <main>
            {/* the boundary sits outside Suspense so that it also
                catches a page chunk that fails to load at all */}
            <PageErrorBoundary>
              <Suspense fallback={<PageFallback />}>
                <Outlet />
              </Suspense>
            </PageErrorBoundary>
          </main>
        </div>
      </div>
    </PartnerProvider>
  );
}
